import { render, staticRenderFns } from "./NeedsDashboardSidebar.vue?vue&type=template&id=bcbd5c9a&scoped=true&"
import script from "./NeedsDashboardSidebar.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsDashboardSidebar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbd5c9a",
  null
  
)

export default component.exports